import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MainMapService } from '../../../shared/service/main-map.service';
import {EsriExpand, EsriReactiveUtils} from '../../../config/esri.module';
import { UserService } from '../../service/user.service';
import { User } from '../../model/user.model';
import { ConfigService } from '../../../config/config.service';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseWidget } from '../../../component/tools/base-widget/base-widget';
import { ENVIRONMENT } from '../../../../environments/environment';

@Component({
    selector: 'app-info',
    templateUrl: './app-info.component.html',
    styleUrls: ['app-info.component.scss'],
    standalone: false
})
export class AppInfoComponent extends BaseWidget implements OnInit {
  // Reference to DOM element of this component
  @ViewChild('appInfoComponentRef', { static: true }) appInfoComponentRef: ElementRef;
  // The logged user
  public user: User;
  stage = ENVIRONMENT.stage.toLowerCase();
  fullVersion = this.configService.appConfig.version;
  public version: string;
  public supportInfo: any;

  public hiddenContainer = false;

  constructor(
    private configService: ConfigService,
    public mainMapService: MainMapService,
    public userService: UserService,
    public widgetNotifyService: WidgetNotifyService,
    private translate: TranslateService
  ) {
    super(mainMapService, widgetNotifyService);
  }

  ngOnInit() {
    // version without revision number
    this.version = this.fullVersion.split('-')[0];

    this.supportInfo = this.configService.appConfig.app_support;
    // set the correct user to the component for view
    this.user = this.userService.user;
    // get the map view
    const mapView: __esri.MapView = this.mainMapService.mapView;
    this.handleExpandWidget(mapView);
  }

  private handleExpandWidget(mapView: __esri.MapView) {
    this.expandWidget = new EsriExpand(this.expandInstanceProperties(mapView));
    this.mainMapService.registerWidget(this.expandWidget);
    // add widget to the main map
    mapView.ui.add(this.expandWidget, 'top-right');
    // Open this widget, will close other widgets
    EsriReactiveUtils.watch(
      () => this.expandWidget.expanded,
      () => {
        if (this.expandWidget.expanded) {
          this.mainMapService.closeOtherWidgets(this.expandWidget);
          this.hiddenContainer = false;
        }
      }
    );
    // expand widget on create
    if (this.expandOnInit) {
      this.expandWidget.expand();
    }
  }

  private expandInstanceProperties(mapView: __esri.MapView): __esri.ExpandProperties {
    return {
      view: mapView,
      id: 'AppInfoComponent',
      content: this.appInfoComponentRef.nativeElement,
      expandIcon: 'information',
      collapseTooltip: this.translate.instant('WIDGET.APPINFO.TOOLTIP'),
      expandTooltip: this.translate.instant('WIDGET.APPINFO.TOOLTIP'),
    };
  }
}
